
export const STANDARD_TRAFFIC_SIZE_TYPE_KEY = [
  { key: 'parentTrafficSize', label: '异常流量(MB)', type: 0 },
  { key: 'httpType', label: 'http流量(MB)', type: 0 },
  { key: 'tcpType', label: 'tcp流量(MB)', type: 0 },
  { key: 'udpType', label: 'udp流量(MB)', type: 0 },
  { key: 'unknownType', label: '其他流量(MB)', type: 0 }];
